<div *ngIf="emailerModel" id="slick-emailer_{{uuid}}" class="slick-emailer">
    <div class="row form-group">
        <div class="col-12">
            <div *ngIf="isSubmitted === true && emailerModel.toEmailAddresses.length === 0" class="errorWrapper showIcons"><div class="text-danger">Email must have at least one email address</div></div>
            <div class="input-group">
                <span class="input-group-text"><span class="fas fa-search"></span></span>
                <input class="form-control" #emailAddressAutocomplete [(ngModel)]="toEmailAddress" placeholder="Email Search..." autofocus />
            </div>
            <slick-auto-complete [inputRef]="emailAddressAutocomplete" textField="emailDisplay" [items]="toEmailAddressList" (onRefresh)="toAddressSearch($event)" (onSelect)="onSelectEmailAddress($event)" (onFreeformTextSelect)="onFreeformTextSelect($event)">
                <ng-template let-emailDisplay [slickAutoCompleteListItemTemplate]>
                    <div style='line-height: 1.1em; font-size: 12px;'>
                        {{emailDisplay.displayName}} [{{emailDisplay.emailAddress}}]
                    </div>
                </ng-template>
            </slick-auto-complete>

            <label>To:&nbsp;</label>
            <div *ngFor="let emailAddress of emailerModel.toEmailAddresses; let idx = index;" class="slick-emailer_email-address alert alert-secondary">{{emailAddress.displayName}} [{{emailAddress.emailAddress}}]<i (click)="deleteEmailAddress(idx)" class="fas fa-times-circle bg-white text-danger ms-1"></i></div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-12">
            <label>Subject:</label>
            <input type="text" class="form-control" [(ngModel)]="emailerModel.subject" />
        </div>
    </div>


    <div class="row form-group">
        <div class="col-12">
            <label>Body:</label>

            <!-- Keep TinyMCE container hidden instead of destroyed -->
            <div [hidden]="!emailerModel?.useOldAccountingEmailTemplates"
                 #tinyMCEContainerRef>
            </div>

            <!-- Formatting for the designed layouts, which are edited in place in the preview below.
                 mousedown is cancelled so clicking a button does not blur the iframe and drop the
                 selection the command is meant to act on. -->
            <div *ngIf="!emailerModel?.useOldAccountingEmailTemplates"
                 class="d-flex align-items-center flex-wrap mb-1">
                <div class="btn-group btn-group-sm me-2">
                    <button type="button" class="btn btn-outline-secondary" title="Bold" [disabled]="!inlineEditingReady" (mousedown)="$event.preventDefault()" (click)="formatPreview('bold')"><i class="fa fa-bold"></i></button>
                    <button type="button" class="btn btn-outline-secondary" title="Italic" [disabled]="!inlineEditingReady" (mousedown)="$event.preventDefault()" (click)="formatPreview('italic')"><i class="fa fa-italic"></i></button>
                    <button type="button" class="btn btn-outline-secondary" title="Underline" [disabled]="!inlineEditingReady" (mousedown)="$event.preventDefault()" (click)="formatPreview('underline')"><i class="fa fa-underline"></i></button>
                    <button type="button" class="btn btn-outline-secondary" title="Bullet list" [disabled]="!inlineEditingReady" (mousedown)="$event.preventDefault()" (click)="formatPreview('insertUnorderedList')"><i class="fa fa-list-ul"></i></button>
                    <button type="button" class="btn btn-outline-secondary" title="Clear formatting" [disabled]="!inlineEditingReady" (mousedown)="$event.preventDefault()" (click)="formatPreview('removeFormat')"><i class="fa fa-remove-format"></i></button>
                </div>
                <div class="btn-group btn-group-sm me-2">
                    <button type="button" class="btn btn-outline-secondary" title="Undo" [disabled]="!inlineEditingReady" (mousedown)="$event.preventDefault()" (click)="formatPreview('undo')"><i class="fa fa-undo"></i></button>
                    <button type="button" class="btn btn-outline-secondary" title="Redo" [disabled]="!inlineEditingReady" (mousedown)="$event.preventDefault()" (click)="formatPreview('redo')"><i class="fa fa-redo"></i></button>
                </div>
                <small class="text-muted">Click the email below to edit it before sending. Buttons, line items and totals are locked.</small>
            </div>

            <!-- Mobile: auto-sizing scrollable iframe -->
            <div *ngIf="isMobile && !emailerModel?.useOldAccountingEmailTemplates"
                 style="
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        overscroll-behavior: revert;
        width: 100%;
        border: 1px solid #ddd;
        border-radius: 6px;
        background: #fff;
      "
                 data-tap-disabled="true">
                <iframe #emailIframeRef
                        [srcdoc]="safeEmailHtml"
                        style="
          width: 100%;
          height: 600px;
          border: 0;
          display: block;
          background: #fff;
        "
                        scrolling="no"
                        (load)="onPreviewLoad($event)"></iframe>
            </div>

            <!-- Desktop: simple fixed-height iframe -->
            <iframe *ngIf="!isMobile && !emailerModel?.useOldAccountingEmailTemplates"
                    [srcdoc]="safeEmailHtml"
                    style="width: 100%; border: 0;"
                    [style.height]="'600px'"
                    (load)="onPreviewLoad($event)">
            </iframe>
        </div>
    </div>



    <div class="row form-group">
        <div class="col-12">
            <label>Attachments:</label>
            <slick-file-drop (filesChanged)="onAttachmentsChanged($event)"></slick-file-drop>
            <slick-file-list [(files)]="emailerModel.attachments"></slick-file-list>
        </div>
    </div>

    <div *ngIf="showButtons"
         class="row form-group"
         [ngStyle]="isMobile ? {
        position: 'sticky',
        bottom: '0',
        padding: '10px 0',
        zIndex: 10
     } : {}">
        <div class="col-12 text-center">
            <button type="button"
                    style="width: 120px; margin-right: 10px;"
                    [slick-button-spinner]="spinnerStatus"
                    class="btn btn-primary"
                    (click)="onSendEmail()">
                <i class="far fa-envelope"></i>&nbsp;Send
            </button>
            <button type="button"
                    style="width: 120px;"
                    class="btn btn-danger"
                    (click)="onCancelEmail()">
                <i class="far fa-times"></i>&nbsp;Cancel
            </button>
        </div>
    </div>

</div>
